export default {
  en: {
    mobileNav: {
      home: "Home", submit: "Submit", live: "Live", analytics: "Analytics", settings: "Settings",
      dashboard: "Dashboard", submitResults: "Submit Results", liveDashboard: "Live Dashboard",
      notifications: "Notifications",
      presidential: "Presidential", parliamentary: "Parliamentary", regional: "Regional",
      council: "Council", senatorial: "Senatorial",
      user: "User", mainMenu: "Main Menu", elections: "Elections", signOut: "Sign Out", back: "Back"
    }
  },
  fr: {
    mobileNav: {
      home: "Accueil", submit: "Soumettre", live: "Direct", analytics: "Analyses", settings: "Paramètres",
      dashboard: "Tableau de bord", submitResults: "Soumettre les résultats", liveDashboard: "Tableau de bord en direct",
      notifications: "Notifications",
      presidential: "Présidentielle", parliamentary: "Législatives", regional: "Régionales",
      council: "Municipales", senatorial: "Sénatoriales",
      user: "Utilisateur", mainMenu: "Menu principal", elections: "Élections", signOut: "Se déconnecter", back: "Retour"
    }
  }
};
